<button mat-icon-button [matTooltip]="toolTip">
    <mat-icon svgIcon="youtube"></mat-icon>
</button>